module.exports = __webpack_public_path__ + "img/integral-privacy.c377cd71.jpg";